<template>
  <div>
    <core-modal-header>Download Digitization Project</core-modal-header>
    <core-modal-body class="max-h-[350px] overflow-y-auto">
      <ul class="list-unstyled my-2 grid grid-cols-2 xs:grid-cols-3 gap-2">
        <li v-for="(download, index) in project.downloads" :key="index" class="text-lg">
          <u-button
            block
            :icon="getIcon(download.type)"
            variant="outline"
            color="heroblue"
            size="lg"
            :label="download.fileName"
            :to="download.url"
            :download="download.fileName"
            :aria-label="download.fileName"
            class="no-underline justify-start"
          />
        </li>
      </ul>
    </core-modal-body>
  </div>
</template>

<script setup>
  const props = defineProps({
    project: Object
  });

  function getIcon(type) {
    switch (type) {
      case DIGITIZATION_FILE_TYPES.videos.type:
        return COMMON_ICONS.video;
      case DIGITIZATION_FILE_TYPES.audios.type:
        return COMMON_ICONS.audio;
      case DIGITIZATION_FILE_TYPES.photos.type:
        return COMMON_ICONS.photo;
      default:
        return COMMON_ICONS.document;
    }
  }
</script>
